import { ACTIONS, PERMANENT_STAFF, Room, STARTING_STAFF_POOL } from '../../Constants';
import {
    ANGRY_GHOST,
    available_docks_for_guest,
    do_i_have_matching_lodging,
    getTradelaneCards,
    GHOST_CARDS,
    SATISFIED_GHOST,
    UNUPGRADED_AMENITY_IDS
} from '../TwoD/Common/CardUtilities';

export function doIHaveTheMaximumStaffAvailableToMe(gamePlayerData) {
    const clockedInStaff = gamePlayerData.robot_market.filter(staffId => staffId === null).length;
    if (gamePlayerData.station.includes(Room.ADVANCED_ROBOT_ROOM_ID)) {
        if (clockedInStaff < 6) return false;
    }
    return clockedInStaff >= 4;
}

export function clockedInTempStaff(gamePlayerData) {
    return STARTING_STAFF_POOL.filter(robot => !gamePlayerData.robot_market.includes(robot));
}


export function clockOutableStaff(gamePlayerData) {
    // Digital-game ruling (2026-07-18, Michael): all Staff are fungible
    // for Clock Out. The physical gold (Permanent) / grey (Chargeable)
    // pawn split is a tabletop aid only — in the video game you use your
    // Staff as you see fit. Any Staff in the available pool may be
    // clocked out, capped ONLY by open Clocked-Out slots (max 6).
    // Mirrors backend GamePlayer.sellable_robots. The Permanent/Advanced
    // identity gates live on the acquisition / Clock-In path, not here.
    let available_spaces_in_market = gamePlayerData.robot_market.filter(r => r == null).length;
    const storageBots = gamePlayerData.robot_storage.filter(
        (robot) => robot !== null);
    let staff = [];
    storageBots.forEach(
        (robot) => {
            if (available_spaces_in_market > 0) {
                --available_spaces_in_market;
                staff.push(robot);
            }
        });
    return staff;
}


export function permanentStaffInStorage(gamePlayerData) {
    return gamePlayerData.robot_storage.filter(
        (robot) => robot !== null && PERMANENT_STAFF.includes(robot));
}


export function clockedOutCount(gamePlayerData) {
    return gamePlayerData.robot_market.filter(
        (robot) => robot !== null).length;
}


export const MAX_CLOCKED_OUT = 6;


export function totalStaffCount(gamePlayerData) {
    let clockedInStaff = gamePlayerData.robot_market.filter(item => item === null).length;
    clockedInStaff += 2; // permanent staff
    return clockedInStaff;
}


export function emptyLodgingCount(gamePlayerData) {
    return gamePlayerData.lodging.filter(room => room == null).length;
}

export function unUpgradedLodgingIndexes(gamePlayerData) {
    let indexes = [];
    gamePlayerData.lodging.forEach(
        (item, index) => {
            if (Room.UNUPGRADED_LODGING_IDS.includes(item)) indexes.push(index);
        });
    return indexes;
}


function unUpgradedLodgings(gamePlayerData) {
    return gamePlayerData.lodging.filter(
        item => Room.UNUPGRADED_LODGING_IDS.includes(item));
}


export function hasUnupgradedLodging(gamePlayerData) {
    return unUpgradedLodgings(gamePlayerData).length > 0;
}


/**
 * This is the index of the first unupgraded room in the player's lodging.
 * @param gamePlayerData
 * @returns {number}
 */
export function firstUnupgradedLodging(gamePlayerData) {
    let tempLodgings = [...gamePlayerData.lodging];
    while (tempLodgings.length){
        let roomId = tempLodgings.pop();
        if (Room.UNUPGRADED_LODGING_IDS.includes(roomId)) {
            return tempLodgings.length;
        }
    }
}


export function ghostedDocks(gamePlayerData) {
    let docks = [];
    gamePlayerData.docks.forEach((cardId, dockIndex) => {
        if (GHOST_CARDS.includes(cardId)) {
            docks.push(dockIndex);
        }
    })
    return docks;
}

export function emptyDocks(gamePlayerData) {
    let docks = [];
    gamePlayerData.docks.forEach((cardId, dockIndex) => {
        if (!cardId) {
            docks.push(dockIndex);
        }
    })
    return docks;
}


export function angryDocks(gamePlayerData) {
    let docks = [];
    gamePlayerData.docks.forEach((cardId, dockIndex) => {
        if (cardId === ANGRY_GHOST) {
            docks.push(dockIndex);
        }
    })
    return docks;
}


export function satisfiedButGhostedDocks(gamePlayerData) {
    let docks = [];
    gamePlayerData.docks.forEach((cardId, dockIndex) => {
        if (cardId === SATISFIED_GHOST) {
            docks.push(dockIndex);
        }
    })
    return docks;
}

/**
 * The number of total ghosts a player has. Max is 8.
 * @param gamePlayerData
 * @returns {number}
 */
export function ghostCount(gamePlayerData) {
    let count = 0;
    gamePlayerData.docks.forEach((cardId, dockIndex) => {
        if (cardId === ANGRY_GHOST) {
            count += 2;
        } else if (cardId === SATISFIED_GHOST) {
            count++;
        }
    })
    return count;
}


/**
 * Upgraded OR Unupgraded core room in storage.
 * @param gamePlayerData
 * @returns {*|null}
 */
export function isThereACoreRoomInStorage(gamePlayerData) {
    const storage = gamePlayerData.storage;
    const rooms = storage.filter(
        roomId => Room.ACTION_ROOMS.includes(roomId));
    return (rooms.length > 0);
}

export function upgradedCoreRoomInStorage(gamePlayerData) {
    const storage = gamePlayerData.storage;
    const upgradedRooms = storage.filter(
        roomId => Room.UPGRADED_ACTION_ROOMS.includes(roomId));
    if (upgradedRooms.length > 0) {
        return storage.indexOf(upgradedRooms[0]);
    }
    return null;
}

export function unUpgradedCoreRoomInStorage(gamePlayerData) {
    const storage = gamePlayerData.storage;
    const upgradedRooms = storage.filter(
        roomId => Room.UNUPGRADED_ACTION_ROOMS.includes(roomId));
    if (upgradedRooms.length > 0) {
        return storage.indexOf(upgradedRooms[0]);
    }
    return null;
}

export function unUpgradedRoomIndexesInStorage(gamePlayerData) {
    let indexes = [];
    gamePlayerData.storage.forEach(
        (roomId, index) => {
            if (
            Room.UNUPGRADED_ACTION_ROOMS.includes(roomId) ||
            Room.UNUPGRADED_AMENITY_IDS.includes(roomId) ||
            Room.UNUPGRADED_BED_IDS.includes(roomId)) {
                indexes.push(index);
            }
        }
        );
    return indexes;
}

export function sellableRoomIndexesInStorage(gamePlayerData) {
    let indexes = [];
    gamePlayerData.storage.forEach((roomId, index) => {
        if (Room.UPGRADED_AMENITY_IDS.includes(roomId) || Room.UPGRADED_BED_IDS.includes(roomId) || Room.DEBRIS_ID === roomId) {
            indexes.push(index);
        }
    });
    return indexes;
}


/**
 * Return the storage index of the first upgraded bed or amenity in storage.
 * @param gamePlayerData
 * @returns {*|null}
 */
export function upgradedAmenitiesAndBedsInStorage(gamePlayerData) {
    const storage = gamePlayerData.storage;
    const upgradedRooms = storage.filter(
        roomId => [
            ...Room.UPGRADED_FACTION_BED_IDS,
            ...Room.UPGRADED_AMENITY_IDS].includes(roomId));
    if (upgradedRooms.length > 0) {
        return storage.indexOf(upgradedRooms[0]);
    }
    return null;
}

export function unUpgradedAmenitiesAndBedsInStorage(gamePlayerData) {
    const storage = gamePlayerData.storage;
    const upgradedRooms = storage.filter(
        roomId => [
            ...Room.UNUPGRADED_FACTION_BED_IDS,
            ...Room.UNUPGRADED_AMENITY_IDS].includes(roomId));
    if (upgradedRooms.length > 0) {
        return storage.indexOf(upgradedRooms[0]);
    }
    return null;
}

export function debrisOnStation(gamePlayerData) {
    const station = gamePlayerData.station;
    const debris = station.filter(
        roomId => roomId === Room.DEBRIS_ID);
    if (debris.length > 0) {
        return station.indexOf(debris[0]);
    }
    return null;
}

export function debrisInStorage(gamePlayerData) {
    const storage = gamePlayerData.storage;
    const debris = storage.filter(
        roomId => roomId === Room.DEBRIS_ID);
    if (debris.length > 0) {
        return storage.indexOf(debris[0]);
    }
    return null;
}


export function howManyUpgradedBedsDoIHave(gamePlayerData) {
    const search = [...gamePlayerData.station, ...gamePlayerData.storage ];
    const result = search.filter(roomId => Room.UPGRADED_FACTION_BED_IDS.includes(roomId));
    return result.length;
}

export function howManyFactionBedsDoIHave(gamePlayerData) {
    const search = [...gamePlayerData.station, ...gamePlayerData.storage ];
    const result = search.filter(roomId => Room.FACTION_BEDS.includes(roomId));
    return result.length;
}

export function howManyFactionBedsDoIHaveInstalled(gamePlayerData) {
    const search = [...gamePlayerData.station ];
    const result = search.filter(roomId => Room.FACTION_BEDS.includes(roomId));
    return result.length;
}

export function howManyUpgradedFactionBedsDoIHaveStored(gamePlayerData) {
    const search = [...gamePlayerData.storage ];
    const result = search.filter(roomId => Room.UPGRADED_FACTION_BED_IDS.includes(roomId));
    return result.length;
}

export function howManyUpgradedAmenitiesDoIHave(gamePlayerData) {
    const search = [...gamePlayerData.station, ...gamePlayerData.storage ];
    const result = search.filter(roomId => Room.UPGRADED_AMENITY_IDS.includes(roomId));
    return result.length;
}

export function howManyAmenitiesDoIHave(gamePlayerData) {
    const search = [...gamePlayerData.station, ...gamePlayerData.storage ];
    const result = search.filter(roomId => Room.AMENITY_IDS.includes(roomId));
    return result.length;
}

export function howManyAmenitiesDoIHaveInstalled(gamePlayerData) {
    const search = [...gamePlayerData.station ];
    const result = search.filter(roomId => Room.AMENITY_IDS.includes(roomId));
    return result.length;
}

export function howManyUpgradedAmenitiesDoIHaveStored(gamePlayerData) {
    const search = [...gamePlayerData.storage ];
    const result = search.filter(roomId => Room.UPGRADED_AMENITY_IDS.includes(roomId));
    return result.length;
}

export function firstUpgradedBedInStorage(gamePlayerData) {
    const search = gamePlayerData.storage;
    const result = search.filter(roomId => Room.UPGRADED_FACTION_BED_IDS.includes(roomId));
    return search.indexOf(result[0]);
}
export function firstUpgradedAmenityInStorage(gamePlayerData) {
    const search = gamePlayerData.storage;
    const result = search.filter(roomId => Room.UPGRADED_AMENITY_IDS.includes(roomId));
    return search.indexOf(result[0]);
}

export function availableAmenities(gameData) {
    let available_amenities = []
    gameData.amenity_pool.map((pool, poolIndex) => {
        let expectedRoomId = Room.UNUPGRADED_AMENITY_IDS[poolIndex];
        if (pool.includes(expectedRoomId)) available_amenities.push(expectedRoomId);
    })
    return available_amenities;
}

export function availableBeds(gameData) {
    let available = []
    gameData.bed_pool.map((pool, poolIndex) => {
        let expectedRoomId = Room.UNUPGRADED_FACTION_BED_IDS[poolIndex];
        if (pool.includes(expectedRoomId)) available.push(expectedRoomId);
    })
    return available;
}


export function isThisLodgingAvailableInPool(gameData, factionId) {
    const factionIndex = factionId - 1;
    const roomId = Room.UNUPGRADED_LODGING_IDS[factionIndex];
    const pool = gameData.lodging_pool[factionIndex];
    return pool.includes(roomId);
}


/**
 * Remove one tile from a shared pool stack, mirroring the engine's
 * remove_from_lodging_pool / remove_from_pool semantics: tiles sit
 * contiguous at the bottom (low indexes), nulls at the top. The topmost
 * tile is the slot just below the first null (or the last slot when the
 * stack is full). Mutates `pool` in place.
 *
 * @returns {boolean} true if a tile was consumed, false if already empty.
 */
function consumePoolTileInPlace(pool) {
    const firstNull = pool.indexOf(null);
    let stackIndex;
    if (firstNull !== -1) {
        stackIndex = firstNull - 1;
        if (stackIndex < 0) return false;  // already depleted
    } else {
        stackIndex = pool.length - 1;
    }
    pool[stackIndex] = null;
    return true;
}


/**
 * Optimistically consume one lodging tile from the shared pool.
 *
 * The frontend only receives a fresh `lodging_pool` on a full game
 * broadcast (end of round / draft). Game.gamePlayerEvent shallow-clones
 * gameData (`{ ...this.gameData }`), so a per-seat update never replaces
 * the pool array — between the per-fate recursive adds inside a single
 * Lodging action the backend depletes the pool silently and the frontend
 * snapshot stays stale. Every seat's AI also targets the same
 * maxTradelaneFaction, so they pile into one faction's stack. Without this
 * the pool guard (availableLodging / isThisLodgingAvailableInPool) keeps
 * reading a stale-available stack and re-picks a faction whose tiles are
 * gone — which the engine rejects with "Missing empty location for
 * lodging." Mutating the shared array in place keeps the guard honest
 * until the next authoritative game payload overwrites it.
 *
 * @returns {boolean} true if a tile was consumed, false if the stack was
 *   already empty.
 */
export function consumeLodgingTileOptimistically(gameData, factionId) {
    const factionIndex = factionId - 1;
    const pool = gameData.lodging_pool[factionIndex];
    if (!pool) return false;
    return consumePoolTileInPlace(pool);
}


/**
 * Optimistically consume one faction-bed tile from the shared bed pool.
 * Same staleness story as consumeLodgingTileOptimistically — the Research
 * picker buys beds out of `bed_pool`, which the frontend never refreshes
 * mid-round. A no-op (returns false) for non-faction-bed room ids, so it
 * is safe to call unconditionally from the generic buy path.
 *
 * @returns {boolean} true if a tile was consumed, false otherwise.
 */
export function consumeBedTileOptimistically(gameData, roomId) {
    const poolIndex = Room.UNUPGRADED_FACTION_BED_IDS.indexOf(roomId);
    if (poolIndex < 0) return false;
    const pool = gameData.bed_pool[poolIndex];
    if (!pool) return false;
    return consumePoolTileInPlace(pool);
}


/**
 * Available Lodging by FactionId;
 * @param gameData
 * @returns {*[]}
 */
export function availableLodging(gameData) {
    let available = []
    gameData.lodging_pool.map((pool, poolIndex) => {
        let expectedRoomId = Room.UNUPGRADED_LODGING_IDS[poolIndex];
        if (pool.includes(expectedRoomId)) {
            available.push(poolIndex + 1);
        }
    })
    return available;
}


export function maxTradelaneFaction(gameData) {
    let tradelanes = getTradelaneCards(gameData.orbits);
    let factionPresence = [ null, 0, 0, 0, 0, 0, 0 ];
    const interestingLanes = [ 0, 1, 2, 3, 6, 7, 8, 9 ];
    interestingLanes.forEach(
        (tradelaneIndex, index) => {
            let card = tradelanes[tradelaneIndex];
            if (card.id) {
                factionPresence[card.faction] += 1;
            }
        });
    const maxFaction = Math.max(...factionPresence);
    const factionId = factionPresence.indexOf(maxFaction);
    return factionId;
}


export function maxTradelaneAmenity(gameData) {
    let tradelanes = getTradelaneCards(gameData.orbits);
    let amenityPresence = [ null, 0, 0, 0, 0, 0, 0 ];
    const interestingLanes = [ 0, 1, 2, 3, 6, 7, 8, 9 ];
    interestingLanes.forEach(
        (tradelaneIndex, index) => {
            let card = tradelanes[tradelaneIndex];
            if (card.id) {
                let amenityIndex = UNUPGRADED_AMENITY_IDS.indexOf(card.amenity);
                amenityPresence[amenityIndex] += 1;
            }
        });
    const maxAmenity = Math.max(...amenityPresence);
    const amenityIndex = amenityPresence.indexOf(maxAmenity);
    return UNUPGRADED_AMENITY_IDS[amenityIndex];
}



export function shuffle(array) {
    let m = array.length, t, i;
    // While there remain elements to shuffle…
    while (m) {
        // Pick a remaining element…
        i = Math.floor(Math.random() * m--);
        // And swap it with the current element.
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    // return array;
}

export function needyGuests(gamePlayerData) {
    return gamePlayerData.docks.filter((cardId) => {
        if (cardId && !GHOST_CARDS.includes(cardId)) {
            if (!do_i_have_matching_lodging(gamePlayerData.lodging, cardId)) {
                return true;
            }
        }
    })
}

export function isDrawAvailable(gameData) {
    return gameData.orbits.slice(0, 6).filter(item => item === null).length > 0;
}

/**
 * If 60% of the cards are in burn pile, the game is close to over.
 * @param gameData
 */
export function isGameAlmostOver(gameData) {
    if (gameData.burn_deck.length === 0) return false;
    const availableCards = [...gameData.guest_deck, ...gameData.discard_deck];
    const orbitCards = gameData.orbits.filter(cardId => cardId != null);
    const allCards = [...availableCards, ...orbitCards, ...gameData.burn_deck];
    const percentageBurned = gameData.burn_deck.length / allCards.length;
    return percentageBurned > 0.55;
}


export function whichStackHasStaffActions(gamePlayerData) {
    const isZeroStaff = gamePlayerData.available_actions[0].includes(ACTIONS.ROBOT_ID);
    if (isZeroStaff) return 0;
    const isZeroLocked = gamePlayerData.locked_action_stacks[0];
    const isOneStaff = gamePlayerData.available_actions[1].includes(ACTIONS.ROBOT_ID);
    if (isOneStaff) return 1;
    const isOneLocked = gamePlayerData.locked_action_stacks[1];
    return null;
}


export function whichStackHasGhostActions(gamePlayerData) {
    const isZeroGhost = gamePlayerData.available_actions[0].includes(ACTIONS.GHOST_ID);
    if (isZeroGhost) return 0;
    const isZeroLocked = gamePlayerData.locked_action_stacks[0];
    const isOneGhost = gamePlayerData.available_actions[1].includes(ACTIONS.GHOST_ID);
    if (isOneGhost) return 1;
    const isOneLocked = gamePlayerData.locked_action_stacks[1];
    return null;
}

export function whichStacksHaveThisAction(gamePlayerData, actionId) {
    const zero = gamePlayerData.available_actions[0].includes(actionId);
    const one = gamePlayerData.available_actions[0].includes(actionId);
    const countZero = gamePlayerData.available_actions[0].filter(item => item === actionId).length
    const countOne = gamePlayerData.available_actions[1].filter(item => item === actionId).length
    return {
        actionId: actionId,
        stacks: [zero, one],
        locked: [
            gamePlayerData.locked_action_stacks[0],
            gamePlayerData.locked_action_stacks[1]],
        count: [
            countZero,
            countOne]
    }
}

function getPlayerBySeat(gameData, seat) {
    let targetList = this.gameData.gameplayer_set.filter(
        gamePlayer => gamePlayer.seat === seat);
    if (targetList.length) return targetList[0];
    return null;
}


function getPlayerById(gameData, gamePlayerId) {
    let targetList = gameData.gameplayer_set.filter(
        gamePlayer => gamePlayer.id === gamePlayerId);
    if (targetList.length) return targetList[0];
    return null;
}


export function haveIAlreadyGone(gameData, gamePlayerData) {
    const playerOne = getPlayerById(gameData, gameData.player_one);
    const playerOneSeat = playerOne.seat;
    let seats = [0, 1, 2, 3, 4, 5];
    while (seats[0] !== playerOneSeat) {
        seats.push(seats.shift());
    }
    const currentSeat = getPlayerById(gameData, gameData.current_player).seat;
    const currentIndex = seats.indexOf(currentSeat);
    const myIndex = seats.indexOf(gamePlayerData.seat);
    return currentIndex > myIndex;
}

export function playersWithAttackableLodging(gameData, gamePlayerData) {
    // Manual §7.2.2 — target picker. Self-target is the Supply path
    // (add / upgrade own lodging via wait_for_add); opponent-target is
    // the attack path.
    //
    // Self: include when there is room to Supply — any empty slot OR
    // any un-upgraded lodging to bump.
    //
    // Opponent: include when ANY lodging slot is non-null. Mirrors the
    // engine's remove_one_lodging, which walks slots 5→0 and removes
    // the first non-null. Predicate used to only check lodging[0] —
    // that hid opponents whose only lodging was at slots 1..5, which
    // happens routinely after a single attack against an opponent
    // whose lodging was only at slot 0.
    return gameData.gameplayer_set.filter(player => {
        if (player.id === gamePlayerData.id) {
            const hasEmptySlot = player.lodging.some(room => room == null);
            const hasUnUpgraded = player.lodging.some(
                room => Room.UNUPGRADED_LODGING_IDS.includes(room));
            return hasEmptySlot || hasUnUpgraded;
        }
        return player.lodging.some(room => room !== null);
    });
}

export function playersWithGhostableDocks(gameData, gamePlayerData) {
    // Manual §7.2.6 — target picker. Self-target is the self-cleanse
    // path (prompt_to_remove_ghosts); opponent-target is the attack
    // path.
    //
    // Self: include when there is anything to cleanse — any Angry or
    // Satisfied ghost on a dock.
    //
    // Opponent: include when any dock is NOT a Satisfied Ghost.
    // Mirrors the engine's available_docks_for_ghost (`is None or
    // != UPGRADED_GHOST_ID`) — empty docks become Angry, Angry docks
    // upgrade to Satisfied. Only an all-Satisfied (38, 38, 38, 38)
    // opponent is saturated. Predicate used to require a non-ghost
    // card present, which hid opponents with empty docks or mixed
    // Angry/empty docks (the common shape mid-game).
    return gameData.gameplayer_set.filter(player => {
        if (player.id === gamePlayerData.id) {
            return player.docks.some(
                cardId => GHOST_CARDS.includes(cardId));
        }
        return player.docks.some(cardId => cardId !== SATISFIED_GHOST);
    });
}


export function playersWhichMayAcceptThisCard(gameData, cardId) {
    // A player may accept the card only if they have at least one dock that
    // can legally receive it -- the SAME calculation the engine's Manual
    // 7.2.5 guard uses (GamePlayer.available_docks_for_guest): an empty dock
    // for any guest, plus Ghost docks for Seekers.
    //
    // The previous body did `player.docks.filter(...)`, which returns the
    // per-player docks array -- always truthy, even when empty -- so the
    // outer filter offered EVERY player as a referral target. That let both
    // the human picker (targetPlayersBySeat) and the AI refer a Guest to a
    // full-docks player who could not place it, wedging the referral.
    return gameData.gameplayer_set.filter(
        player => available_docks_for_guest(player.docks, cardId).length > 0);
}


export function scorableDocks(gamePlayerData) {
    let docks = [];
    gamePlayerData.docks.forEach((cardId, dock) => {
        if (cardId && !GHOST_CARDS.includes(cardId)) docks.push(dock);
    })
    return docks;
}
